import {
    doNotModifyCodeAbove,
    doNotModifyCodeBelow,
} from "@js/educationContent/CairoMummiesContent/eduConstants";

export const lesson0DefaultStartCode = `use debug::PrintTrait;

fn main() {
    let is_morning = true;
    if is_morning {
        ('Good morning!').print();
    }
    ${doNotModifyCodeAbove}`;

export const lesson0DefaultMiddleCode = `    //TODO: Finish the rest of this line like the example! Or make it be false!
    let `;

export const lesson0DefaultEndCode = `    ${doNotModifyCodeBelow}
    if is_evening {
        ('Good evening!').print();
    }
}

#[test]
fn test_compile() {
    assert(1 == 1, 'Surprising');
    main();
}`;
